import { render, staticRenderFns } from "./FormServicePlatform.vue?vue&type=template&id=0d644216&scoped=true&"
import script from "./FormServicePlatform.vue?vue&type=script&lang=js&"
export * from "./FormServicePlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d644216",
  null
  
)

export default component.exports